import { useCallback } from 'react';

import ModalImpressionEvent from '~/events/ModalImpressionEvent';
import useImpression from '~/hooks/useImpression';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';
import type { ModalScreen } from '~/utils/modalProperties';

// Once per screen per opening: a new opening of the modal is a new modal_open_id, so it is seen
// again on the same page view.
export default function useModalImpression<T extends HTMLElement>(
  screen: ModalScreen
) {
  const { isBot } = useRootData();
  const { guestId } = useUser();

  const track = useCallback(() => {
    new ModalImpressionEvent({ guestId, isBot, screen }).track();
  }, [guestId, isBot, screen]);

  return useImpression<T>(track, {
    enabled: !isBot,
    variant: `${screen.modalOpenId}|${screen.modalStep ?? ''}`
  });
}
